export default class LocationTileHover {
	constructor(el) {

		this.tile			= el
		this.theme 			= ' ' + this.tile.dataset.theme
		this.section		= this.tile.closest('.section')
		this.sectionClasses	= this.section.classList.toString()
		this.newClasses		= this.section.classList + this.theme
		this.hoverTile 		= this.hoverTile.bind(this)
		this.leaveTile 		= this.leaveTile.bind(this)

		this.tile.addEventListener('mouseenter', this.hoverTile )
		this.tile.addEventListener('mouseleave', this.leaveTile )

	}

	hoverTile() {

		// console.log(this.sectionClasses)

		this.section.className = this.newClasses;

	}

	leaveTile() {

		this.section.className = this.sectionClasses;

	}
}
